export default "__VITE_ASSET__cfc8ca6a__"